import React from 'react';

import FormLabel from '../FormLabel';
import ErrorNotice from '../ErrorNotice';
import { selectField } from '../shared/PropTypes';
import { generateClassName, generateErrors } from '../shared/generate';

const SelectField = (props) => {
  const {
    allowBlank = false,
    blankText = null,
    disabled = false,
    error = [],
    hideErrorText = false,
    isOptionDisabled = null,
    keyOnly = false,
    klass = null,
    required = false,
    selectOptions = [],
    sortBy = 'key',
    sortOptions = true,
    subtext = null,
    tooltip = null,
    value = '',
    handleChange,
    id,
    label,
    spanKlass,
    children,
  } = props;

  const className = generateClassName(klass);
  const { errorMessage, errorBool } = generateErrors(error);

  function renderOptions() {
    const isArray = Array.isArray(selectOptions);
    const iterator = isArray
      ? selectOptions
      : Object.keys(selectOptions);

    if (sortOptions) {
      if (sortBy === 'key') {
        iterator.sort();
      } else if (sortBy === 'value') {
        // eslint-disable-next-line react/prop-types
        iterator.sort((a, b) => selectOptions[a].localeCompare(selectOptions[b]));
      }
    }

    function optionText(option) {
      return (isArray || keyOnly) ? option : selectOptions[option];
    }

    return (
      <>
        {iterator.map((option) => (
          <option
            key={option}
            value={option}
            disabled={isOptionDisabled ? isOptionDisabled(option) : false}
          >
            {optionText(option)}
          </option>
        ))}
      </>
    );
  }

  return (
    <div className={className}>
      <FormLabel
        label={label}
        htmlFor={id}
        tooltip={tooltip}
        required={required}
        spanKlass={spanKlass}
      >
        <div className="select-wrapper">
          <select
            id={id}
            name={id}
            value={value || ''}
            error={errorBool}
            disabled={disabled}
            onChange={handleChange}
            className={value ? '' : 'blank-text'}
          >
            {
              allowBlank
                && (
                  blankText
                    ? <option value="" aria-label="blank">{blankText}</option>
                    : <option value="" aria-label="blank" />
                )
            }
            {children || renderOptions()}
          </select>
          {subtext && (<span className="subtext">{subtext}</span>)}
        </div>
      </FormLabel>
      {
        !hideErrorText && (
          <ErrorNotice error={errorMessage} />
        )
      }
    </div>
  );
};

SelectField.propTypes = selectField.props;

export default SelectField;
